import styled, { css } from 'styled-components/macro'

import Bubble from 'assets/timeline-bubble.png'
import { mq } from 'styles/mq'

export type BubblePosition = { $position: 'top' | 'bottom' }

export const BubbleWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  mask: url('${Bubble}') 100% 0 / auto 100% no-repeat;
  transform-origin: 85% 95%;
  transform: translate3d(0, 0, 0);
  transition: transform 0.3s;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    mix-blend-mode: multiply;
    background: url('${Bubble}') 0 0 / auto 100% no-repeat;
  }

  li:hover &,
  li:focus-visible & {
    transform: rotate(3deg);
  }
`

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  mask: url('${Bubble}') 50% 0 / auto 100% no-repeat;
`

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: filter 0.3s;
  filter: saturate(0);

  li:hover &,
  li:focus-visible & {
    filter: none;
  }

  &:not([dir='rtl'] &) {
    transform: rotateY(-180deg);
  }
`

export const Container = styled.div<BubblePosition & { $isHidden: boolean }>`
  position: relative;
  width: var(--bubble-width);
  aspect-ratio: 403 / 328;
  grid-area: bubble;

  ${mq.smallOnly} {
    max-width: 80%;
    margin: -1% -5%;
  }

  ${props =>
    props.$isHidden &&
    css`
      visibility: hidden;

      ${mq.smallOnly} {
        display: none;
      }
    `}

  ${mq.medium} {
    margin-inline-start: -7%;
  }

  &:not([dir='rtl'] &) {
    transform: rotateY(180deg);
  }

  ${props =>
    props.$position === 'top' &&
    css`
      ${mq.medium} {
        align-self: end;
      }
    `}

  ${props =>
    props.$position === 'bottom' &&
    css`
      ${mq.medium} {
        transform: rotateX(180deg);

        &:not([dir='rtl'] &) {
          transform: rotateX(180deg) rotateY(180deg);
        }

        ${Image} {
          transform: rotateX(-180deg);

          &:not([dir='rtl'] &) {
            transform: rotateX(-180deg) rotateY(-180deg);
          }
        }
      }
    `}
`
